import { useEffect, useState } from "react";
import { Button, Col, Form, Row, Stack } from "react-bootstrap";
import companySignUp from "./services";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import StatusNavigator from "../navigator";
import { Alert, Snackbar } from "@mui/material";

const LandingPage = () => {
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");

  const [showAlert, setShowAlert] = useState(false);
  const handleCloseAlert = () => setShowAlert(false);

  const handleClosse = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const dataJson = {
    email: "",
    password: "",
    name: "",
    phoneNo: "",
    ssn: "",
  };

  const [errors, setErrors] = useState({
    email: "",
    password: "",
    name: "",
    phoneNo: "",
    ssn: "",
  });
  const [data, setData] = useState(dataJson);

  const setValue = (e) => {
    const { name, value } = e.target;
    const phoneRegex = /^[0-9\b]+$/;
    const spaceRegex = /\s{2,}/g; // Regex to trim consecutive spaces

    let sanitizedValue = value.replace(spaceRegex, " ").trim(); // Replace consecutive spaces with single space and trim

    if (name === "phoneNo" || name === "ssn") {
      if (sanitizedValue === "" || phoneRegex.test(sanitizedValue)) {
        setData({ ...data, [name]: sanitizedValue });
      }
    } else {
      setData({ ...data, [name]: sanitizedValue });
    }
  };

  const signUp = async () => {
    try {
      //  debugger;
      const response = await companySignUp.signUp(data);

      console.log("response_SIGNIN", response);

      if (response.status === 201) {
        setShow(false);
        setShowAlert(true);
        setData({});
        setValidated(false);
        // Swal.fire({
        //   // position: "top-end",
        //   icon: "success",
        //   title: "New Account has been Created",
        //   showConfirmButton: false,
        //   timer: 1500,
        // });
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 401) {
          setMessage(error.response.data.message);
          setSeverity("error");
          setOpen(true);
        }

        if (error.response.status === 400) {
          console.log(error);
          setMessage(error.response.data.message);
          setSeverity("error");
          setOpen(true);
          const errorResponse = error.response.data;
          if (errorResponse.errorState) {
            // Handle error messages from the server for both email and password
            Object.keys(errorResponse.errorState).forEach((key) => {
              const errorMessage = errorResponse.errorState[key][0];
              setErrors((prevErrors) => ({
                ...prevErrors,
                [key]: errorMessage,
              }));
            });
          } else {
            // Show a generic error message if errorState is not present
            // setMessage("The request is invalid.");
            // setSeverity("error");
            // setOpen(true);
          }
        }
      } else {
        setMessage("An error occurred while LogIn");
        setSeverity("error");
        setOpen(true);
      }
    } finally {
      // setLoad(false);
    }
  };

  // const handleSubmit = (event) => {
  //   debugger;
  //   const form = event.currentTarget;
  //   if (form.checkValidity() === false) {
  //     event.preventDefault();
  //     event.stopPropagation();
  //   } else {

  //     signUp();

  //   }

  //   setValidated(true);
  // };
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
    signUp();
  };

  const [planeToggal, setPlaneToggal] = useState("1");
  const [getPricePlane, setGetPricePlane] = useState([]);
  const [load, setLoad] = useState(false);
  const [professionalPrice, setProfessionalPrice] = useState(20);
  function getPlane() {
    companySignUp
      .pricePlann()
      .then((respon) => {
        console.log("pricePlann", respon.data.data);
        setGetPricePlane(respon.data.data);
        setLoad(true);
      })
      .catch((e) => {
        console.log(e);
      });
  }
  useEffect(() => {
    getPlane();
  }, []);

  const [showForm, setShowForm] = useState(false);

  const handleCloseForm = () => setShowForm(false);
  const handleShowForm = () => setShowForm(true);
  const [contactValidated, setContactValidated] = useState(false);

  const messsageDataSchema = {
    name: "",
    email: "",
    phoneNumber: "",
    message: "",
  };
  const [messsageData, setMesssageData] = useState(messsageDataSchema);
  function typeMessage(event) {
    const { name, value } = event.target;
    const phoneRegex = /^[0-9\b]+$/;
    // Check if the input value matches the phone number regex

    if (name === "phoneNumber") {
      if (phoneRegex.test(value) || value === "") {
        setMesssageData({ ...messsageData, [name]: value });
      }
    } else {
      setMesssageData({ ...messsageData, [name]: value });
    }

    console.log("typeMessage", messsageData);
  }
  function sendMessage() {
    companySignUp
      .sendMessageApi(messsageData)
      .then((respons) => {
        console.log(respons);
        Swal.fire({
          // position: "top-end",
          icon: "success",
          title: "Message sent successfully!",
          showConfirmButton: false,
          timer: 1500,
        });
        setShowForm(false);
      })
      .catch((error) => {
        setMessage(error.response.data.message);
        setSeverity("error");
        setOpen(true);
        console.log("error", error.response.data.message);
      });
  }
  const contactFormSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      if (
        (messsageData.name !== "",
        messsageData.email !== "",
        messsageData.phoneNumber !== "",
        messsageData.message !== "")
      ) {
        sendMessage();
      }
    }

    setContactValidated(true);
  };

  return (
    <div style={{ fontFamily: "'Poppins', sans-serif" }}>
      <StatusNavigator />
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container-fluid">
          <div className="logo">
            <a href="index.html">
              <img src="/assets/img/tappme-logo.png" />
            </a>
          </div>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav">
              <li className="nav-item">
                <a href="#home" className="nav-link">
                  Home
                </a>
              </li>
              <li className="nav-item">
                <a href="#about" className="nav-link">
                  Products
                </a>
              </li>
              <li className="nav-item">
                <a href="#plan" className="nav-link">
                  Subscription plans
                </a>
              </li>
            </ul>
            <div className="others-option">
              <div className="d-flex align-items-center">
                <Link to="/company" className="pt-2 pe-4 login-link">
                  Sign in
                </Link>
                <div className="option-item">
                  <a className="default-btn" href="#plan">
                    Start Free Trial
                    <span></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <div id="home" className="main-banner">
        <div className="d-table">
          <div className="d-table-cell">
            <div className="container-fluid">
              <div className="row align-items-center">
                <div className="col-lg-6 pe-lg-5">
                  <div className="banner-content">
                    <h1 className="mb-4">
                      Welcome to the <span className="text-blue">future</span>{" "}
                      of efficient work management with the{" "}
                      <span className="text-blue">TAPP ME</span> NFC App
                    </h1>
                    <p className="mb-4">
                      Your all-in-one solution designed to streamline
                      registration processes, enhance workflow visibility, and
                      drive productivity across a wide range of industries
                    </p>
                    <div className="about-btn mt-4">
                      <a
                        href="#"
                        className="default-btn2"
                        style={{ marginRight: "15px" }}
                      >
                        {" "}
                        Start Free Trial
                      </a>
                      <a href="#" className="default-btn3">
                        {" "}
                        View Subscription Plans
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="banner-image">
                    <img src="/assets/img/tapme-mobile.png" alt="image" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="fun-facts-area pt-100 pb-70">
        <div className="container">
          <div className="section-title">
            <h2>Key Features</h2>
            <div className="bar"></div>
          </div>
          <div className="bg_white">
            <div className="row align-items-center">
              <div className="col-lg-4 col-sm-6">
                <div className="single-fun-fact">
                  <div className="icon">
                    <img
                      src="/assets/img/mdi_clock-fast.svg"
                      alt="clock-fast"
                    />
                  </div>
                  <h3>
                    <span>Seamless Registration</span>
                  </h3>
                  <p>
                    With TAPP ME NFC App, employees and visitors can
                    effortlessly check in and out using NFC technology
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="single-fun-fact">
                  <div className="icon">
                    <img
                      src="/assets/img/tabler_report.svg"
                      alt="tabler_report"
                    />
                  </div>
                  <h3>
                    <span>Subscription model</span>
                  </h3>
                  <p>
                    {" "}
                    TAPP ME NFC App offers subscription plans that can be
                    tailored to fit your organization's unique requirements
                  </p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="single-fun-fact">
                  <div className="icon">
                    <img
                      src="/assets/img/carbon_flash-filled.svg"
                      alt="carbon_flash-filled"
                    />
                  </div>
                  <h3>
                    <span>Boost Efficiency</span>
                  </h3>
                  <p>
                    With real-time insights into tasks, attendance, and
                    progress, TAPP ME NFC App Boost up the efficiency
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="about" className="about-area pb-100">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="about-image">
                <img src="/assets/img/about.jpg" alt="image" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="about-content ps-lg-5 pt-2">
                <h3>NFC Card Electronic Registration</h3>
                <p className="mb-0">
                  The main goal and objective of this part of the app is to
                  change physical ID06 cards that are used to register people
                  when they enter or leave any working sites, like construction,
                  medical, office space, gym…
                </p>
                <div className="about-btn mt-5">
                  <a href="#" className="default-btn3">
                    {" "}
                    View Subscription Plans
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="about" className="about-area pb-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="about-content pe-lg-5">
                <h3>Electronic Report From The Field</h3>
                <p className="mb-0">
                  Electronic reports from the field should be a very simple and
                  easy tool to help workers on the field to take pictures or
                  videos and automatically generate reports towards their
                  supervisors in PDF format over the mail.
                </p>
                <div className="about-btn mt-5">
                  <a href="#" className="default-btn3">
                    {" "}
                    View Subscription Plans
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="about-image">
                <img src="/assets/img/tapme-mobile2.png" alt="image" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="pricing-area pt-0 pb-70" id="plan">
        <div className="container">
          <div className="section-title">
            <h2>Subscription Plans</h2>
            <div className="bar"></div>
          </div>
          <div className="tab pricing-list-tab">
            <ul className="tabs">
              <li>
                <button
                  className={`btn ${
                    planeToggal == "1" ? "default-btn2" : null
                  }`}
                  onClick={() => setPlaneToggal(1)}
                >
                  1 year
                </button>
              </li>
              <li>
                <button
                  className={`btn ${
                    planeToggal == "3" ? "default-btn2" : null
                  }`}
                  onClick={() => setPlaneToggal(3)}
                >
                  3 years
                </button>
              </li>
            </ul>
            {load ? (
              <div className="tab_content">
                <div className="tabs_item">
                  <div className="row">
                    <div className="col-lg-3 col-md-6">
                      <div className="single-pricing-table">
                        <div className="pricing-header">
                          <h3>Personal</h3>
                        </div>
                        <div className="price mb-4">
                          $0 <sub> Free</sub>
                        </div>
                        <h6 className="mb-3">
                          For {getPricePlane[0].shareCount} user
                        </h6>
                        <div
                          className="border_bottom"
                          style={{ opacity: 0 }}
                        ></div>
                        <div className="pricing-btn2"></div>
                        <div className="pricing-btn ps-3">
                          <a className="default-btn3 px-5" onClick={handleShow}>
                            Sign up
                            <span></span>
                          </a>
                        </div>
                        <div
                          className="border_bottom"
                          style={{ opacity: 0 }}
                        ></div>
                        <ul></ul>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                      <div className="single-pricing-table">
                        <div className="pricing-header">
                          <h3>{getPricePlane[1].planName}</h3>
                        </div>
                        <div className="price mb-4">
                          ${getPricePlane[1].price} <sub> /month</sub>
                        </div>
                        <h6 className="mb-3">
                          {getPricePlane[1].shareCount} users
                        </h6>
                        <div className="border_bottom"></div>
                        <div className="pricing-btn2">
                          <h6 className="">
                            {" "}
                            Total ${getPricePlane[1].priceOfPlan}/ month
                          </h6>
                        </div>
                        <div className="pricing-btn ps-3">
                          <a className="default-btn3 px-5" onClick={handleShow}>
                            Buy
                            <span></span>
                          </a>
                        </div>
                        <div className="border_bottom"></div>
                        <ul>
                          {getPricePlane[1].features.map((item) => (
                            <li>{item.features}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                      <div className="single-pricing-table">
                        <div className="pricing-header">
                          <h3>{getPricePlane[2].planName}</h3>
                        </div>
                        <div className="price mb-2">
                          ${getPricePlane[2].price} <sub> per user/month</sub>
                        </div>
                        <h6 className="">
                          <input
                            type="text"
                            min={20}
                            className="form-control  d-inline"
                            placeholder="20"
                            value={professionalPrice}
                            id="number"
                            style={{ width: "100px" }}
                            onChange={(e) => {
                              console.log(e.target.value);
                              const numberRegex = /^[0-9\b]+$/;
                              if (
                                numberRegex.test(e.target.value) ||
                                e.target.value === ""
                              ) {
                                setProfessionalPrice(e.target.value);
                              }
                            }}
                          />{" "}
                          Users
                        </h6>
                        <div className="border_bottom"></div>
                        <div className="pricing-btn2">
                          <h6 className="mb-3">
                            {professionalPrice >= 20 ? (
                              <>
                                Total $
                                {getPricePlane[2].price * professionalPrice}/
                                month
                              </>
                            ) : (
                              <span style={{ fontSize: "12px", color: "#f00" }}>
                                Please add users 20 or more then{" "}
                              </span>
                            )}
                          </h6>
                        </div>
                        <div className="pricing-btn ps-3">
                          <a className="default-btn3 px-5" onClick={handleShow}>
                            Buy
                            <span></span>
                          </a>
                        </div>
                        <div className="border_bottom"></div>
                        <ul>
                          {getPricePlane[2].features.map((item) => (
                            <li>{item.features}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                      <div className="single-pricing-table2">
                        <div className="pricing-header">
                          <h3 className="text-white">Enterprise</h3>
                        </div>
                        <div className="pric mb-4 text-center py-5">
                          <img src="/assets/img/buildings.png" />
                        </div>
                        <div className="pricing-btn ps-3 mt-5">
                          <a href="#" className="default-btn3 px-5">
                            Contact us
                            <span></span>
                          </a>
                        </div>
                        <div className="border_bottom mt-5"></div>
                        <p className="ps-3 text-white">
                          For construction companies seeking robust governance
                          and administration features at an enterprise level.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="tabs_item">
                  <div className="row">
                    <div className="col-lg-3 col-md-6">
                      <div className="single-pricing-table">
                        <div className="pricing-header">
                          <h3>Personal2</h3>
                        </div>
                        <div className="price mb-4">
                          $0 <sub> Free</sub>
                        </div>
                        <h6 className="mb-3">For 1 user</h6>
                        <div
                          className="border_bottom"
                          style={{ opacity: 0 }}
                        ></div>
                        <div className="pricing-btn2"></div>
                        <div className="pricing-btn ps-3">
                          <a href="#" className="default-btn3 px-5">
                            Sign up
                            <span></span>
                          </a>
                        </div>
                        <div
                          className="border_bottom"
                          style={{ opacity: 0 }}
                        ></div>
                        <ul></ul>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                      <div className="single-pricing-table">
                        <div className="pricing-header">
                          <h3>Startup</h3>
                        </div>
                        <div className="price mb-4">
                          $8 <sub> /month</sub>
                        </div>
                        <h6 className="mb-3">20 users</h6>
                        <div className="border_bottom"></div>
                        <div className="pricing-btn2">
                          <h6 className="mb-3"> Total $8/ month</h6>
                        </div>
                        <div className="pricing-btn ps-3">
                          <a href="#" className="default-btn3 px-5">
                            Buy
                            <span></span>
                          </a>
                        </div>
                        <div className="border_bottom mt-5"></div>
                        <ul>
                          <li>Only NFC registeration</li>
                          <li>15 days free trial with limited functionality</li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                      <div className="single-pricing-table">
                        <div className="pricing-header">
                          <h3>Professional</h3>
                        </div>
                        <div className="price mb-4">
                          $4.8 <sub> per user/month</sub>
                        </div>
                        <h6 className="mb-3">20+ users</h6>
                        <div className="border_bottom"></div>
                        <div className="pricing-btn2">
                          <h6 className="mb-3">Total $40/ month</h6>
                          <input
                            type="email"
                            className="form-control ms-3 d-inline"
                            placeholder="12"
                            id="email"
                            style={{ width: "100px" }}
                          />{" "}
                          Users
                        </div>
                        <div className="pricing-btn ps-3">
                          <a href="#" className="default-btn3 px-5">
                            Buy
                            <span></span>
                          </a>
                        </div>
                        <div className="border_bottom mt-5"></div>
                        <ul>
                          <li>TAPP ME app</li>
                          <li>15 days free trial with limited functionality</li>
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                      <div className="single-pricing-table2">
                        <div className="pricing-header">
                          <h3 className="text-white">Enterprise</h3>
                        </div>
                        <div className="pric mb-4 text-center py-5">
                          <img src="/assets/img/buildings.png" />
                        </div>
                        <div className="pricing-btn ps-3 mt-5">
                          <a href="#" className="default-btn3 px-5">
                            Contact us
                            <span></span>
                          </a>
                        </div>
                        <div className="border_bottom mt-5"></div>
                        <p className="ps-3 text-white">
                          {/* For construction companies seeking robust governance and
                            administration features at an enterprise level. */}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </section>
      <section className="blog-area pb-70">
        <div className="container">
          <div className="section-title">
            <h2>Read our Blogs</h2>
            <div className="bar"></div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6">
              <div className="single-blog">
                <div className="image">
                  <a href="#">
                    <img
                      src="/assets/img/blog1.png"
                      alt="image"
                      className="w-100"
                    />
                  </a>
                </div>
                <div className="content">
                  <h3>
                    <a href="#">
                      Unlocking the Potential of NFC in Electronic Reporting
                    </a>
                  </h3>
                  <p>
                    Explore the transformative role of Near Field Communication
                    (NFC) technology in revolutionizing electronic reporting
                    systems...{" "}
                    <a href="#" className="read-more">
                      Read More
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-blog">
                <div className="image">
                  <a href="#">
                    <img
                      src="/assets/img/blog2.png"
                      alt="image"
                      className="w-100"
                    />
                  </a>
                </div>
                <div className="content">
                  <h3>
                    <a href="#">
                      The Future of Electronic Reporting: A Deep Dive into NFC
                      Integration
                    </a>
                  </h3>
                  <p>
                    EDelve into the future of electronic reporting as we examine
                    the integration of NFC technology...{" "}
                    <a href="#" className="read-more">
                      Read More
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-blog">
                <div className="image">
                  <a href="#">
                    <img
                      src="/assets/img/blog3.png"
                      alt="image"
                      className="w-100"
                    />
                  </a>
                </div>
                <div className="content">
                  <h3>
                    <a href="#">
                      NFC and Electronic Reporting: Enhancing Efficiency and
                      Accuracy
                    </a>
                  </h3>
                  <p>
                    ELearn about the synergy between NFC and electronic
                    reporting, focusing on the ways in which NFC technology is
                    enhancing the efficiency of data...{" "}
                    <a href="#" className="read-more">
                      Read More
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div className="pricing-btn ps-3 text-center">
              <a href="#" className="default-btn3 px-5 mt-5">
                Read Blogs
                <span></span>
              </a>
            </div>
          </div>
        </div>
      </section>
      <section className="footer-area pt-100 pb-70">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 col-sm-6">
              <div className="single-footer-widget">
                <a href="#" className="logo">
                  <img src="/assets/img/tappme-logo2.png" alt="tappme-logo2" />
                </a>
                <p className="mb-5 text-white">
                  TAPP ME is a product of MITAWAY AB. It is your all-in-one
                  solution designed to streamline registration processes,
                  enhance workflow visibility, and drive productivity across a
                  wide range of industries
                </p>
                <img src="/assets/img/badge.png" alt="tappme-logo2" />
                <img src="/assets/img/badge2.png" alt="tappme-logo2" />
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="single-footer-widget pl-5">
                <h3>Quick Links</h3>
                <ul className="list">
                  <li>
                    <a href="#">Home</a>
                  </li>
                  <li>
                    <a href="#">Services</a>
                  </li>
                  <li>
                    <a href="#">About us</a>
                  </li>
                  <li>
                    <a onClick={() => handleShowForm()}>Contact us</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="single-footer-widget">
                <h3>Get in Touch</h3>
                <ul className="info-list clearfix">
                  <li className="mb-4">
                    <i>
                      <img src="/assets/img/mail.svg" alt="tappme-logo2" />
                    </i>{" "}
                    <a href="mailto:info@tandtftc.org" className="text-white">
                      office@mitaway.com
                    </a>
                  </li>
                  <li className="mb-4">
                    <i>
                      <img src="/assets/img/phone.svg" alt="tappme-logo2" />
                    </i>{" "}
                    <a href="tel:+46 73 144 42 38" className="text-white">
                      +46 73 144 42 38
                    </a>
                  </li>
                  <li>
                    <i>
                      <img src="/assets/img/location.svg" alt="tappme-logo2" />
                    </i>{" "}
                    Åkerbyvägen 368187 38 Stockholm, Sweden
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="copy-right">
        <div className="container">
          <div className="copy-right-content">
            <div className="row">
              <div className="col-lg-6 col-sm-6">
                <p className="text-white">
                  Copyright December 17, 2023© MITAWAY AB | ALL RIGHTS RESERVED
                </p>
              </div>
              <div className="col-lg-6 col-sm-6 single-footer-widget">
                <ul className="social-list">
                  <li>
                    <a href="#" target="_blank">
                      <img src="/assets/img/facebook.svg" alt="tappme-logo2" />
                    </a>
                  </li>
                  <li>
                    <a href="#" target="_blank">
                      <img src="/assets/img/linkedin.svg" alt="tappme-logo2" />
                    </a>
                  </li>
                  <li>
                    <a href="#" target="_blank">
                      <img src="/assets/img/instagram.svg" alt="tappme-logo2" />
                    </a>
                  </li>
                  <li>
                    <a href="#" target="_blank">
                      <img src="/assets/img/twitter.svg" alt="tappme-logo2" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        //backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
              <div className="logog py-4">
                <div className="text-center pb-3">
                  <img
                    className="me-2 mb-3"
                    src="assets/images/tapme-icon.svg"
                    width="66"
                    alt="tapme-logo"
                  />
                  <h3 className="card-title mb-3">Sign up</h3>
                </div>
                <Form
                  className="form-body pt-2"
                  noValidate
                  validated={validated}
                >
                  <div className="row g-3">
                    <div className="col-12">
                      <Form.Group
                        controlId="validationCustom01"
                        className="ms-auto position-relative"
                      >
                        <div className="position-absolute translate-middle-y2 search-icon1 px-3">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="17"
                            viewBox="0 0 20 17"
                            fill="none"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M7.96912 2.94814e-07H11.7392C13.4238 -1.42388e-05 14.7582 -2.58163e-05 15.8024 0.140374C16.8772 0.284866 17.747 0.589307 18.433 1.27531C19.119 1.96131 19.4235 2.83118 19.568 3.9059C19.7084 4.95018 19.7083 6.28451 19.7083 7.96912V8.07254C19.7083 9.75716 19.7084 11.0915 19.568 12.1358C19.4235 13.2105 19.119 14.0804 18.433 14.7664C17.747 15.4524 16.8772 15.7568 15.8024 15.9013C14.7582 16.0417 13.4238 16.0417 11.7392 16.0417H7.96912C6.28451 16.0417 4.95018 16.0417 3.9059 15.9013C2.83118 15.7568 1.96131 15.4524 1.27531 14.7664C0.589307 14.0804 0.284866 13.2105 0.140374 12.1358C-2.58163e-05 11.0915 -1.42388e-05 9.75716 2.94814e-07 8.07255V7.96912C-1.42388e-05 6.2845 -2.58163e-05 4.95018 0.140374 3.9059C0.284866 2.83118 0.589307 1.96131 1.27531 1.27531C1.96131 0.589307 2.83118 0.284866 3.9059 0.140374C4.95018 -2.58163e-05 6.28451 -1.42388e-05 7.96912 2.94814e-07ZM4.08911 1.50311C3.16686 1.62711 2.63552 1.85964 2.24758 2.24758C1.85964 2.63552 1.62711 3.16686 1.50311 4.08911C1.37646 5.03114 1.375 6.27292 1.375 8.02083C1.375 9.76875 1.37646 11.0105 1.50311 11.9526C1.62711 12.8748 1.85964 13.4061 2.24758 13.7941C2.63552 14.182 3.16686 14.4146 4.08911 14.5386C5.03114 14.6652 6.27291 14.6667 8.02083 14.6667H11.6875C13.4354 14.6667 14.6772 14.6652 15.6192 14.5386C16.5415 14.4146 17.0728 14.182 17.4608 13.7941C17.8487 13.4061 18.0812 12.8748 18.2052 11.9526C18.3319 11.0105 18.3333 9.76875 18.3333 8.02083C18.3333 6.27292 18.3319 5.03114 18.2052 4.08911C18.0812 3.16686 17.8487 2.63552 17.4608 2.24758C17.0728 1.85964 16.5415 1.62711 15.6192 1.50311C14.6772 1.37646 13.4354 1.375 11.6875 1.375H8.02083C6.27292 1.375 5.03114 1.37646 4.08911 1.50311ZM3.82602 3.91404C4.06909 3.62235 4.5026 3.58294 4.79429 3.82601L6.77328 5.47517C7.62849 6.18785 8.22225 6.68105 8.72353 7.00345C9.20878 7.31554 9.53785 7.4203 9.85417 7.4203C10.1705 7.4203 10.4996 7.31554 10.9848 7.00345C11.4861 6.68105 12.0798 6.18785 12.9351 5.47517L14.914 3.82601C15.2057 3.58294 15.6392 3.62235 15.8823 3.91404C16.1254 4.20573 16.086 4.63924 15.7943 4.88232L13.7808 6.56019C12.9684 7.23729 12.3098 7.7861 11.7286 8.15991C11.1231 8.54932 10.5335 8.7953 9.85417 8.7953C9.17485 8.7953 8.5852 8.54932 7.97975 8.15991C7.39853 7.7861 6.73999 7.2373 5.9275 6.5602L3.91404 4.88232C3.62235 4.63924 3.58294 4.20573 3.82602 3.91404Z"
                              fill="#1E73FF"
                            />
                          </svg>
                        </div>
                        <Form.Control
                          className="form-control radius-4 ps-5  mt-3 height-50"
                          required
                          type="email"
                          placeholder="Email Address"
                          name="email"
                          onChange={setValue}
                          pattern=".+@[^@\s]+\.[^.\s]+"
                        />
                        <Form.Control.Feedback
                          type="invalid"
                          style={{ position: "absolute" }}
                        >
                          {errors.email}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </div>
                    <div className="col-12">
                      <Form.Group
                        controlId="validationCustom01"
                        className="ms-auto position-relative"
                      >
                        <div className="position-absolute translate-middle-y2 search-icon1 px-3">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M14.948 1.25H17.052C17.9505 1.24997 18.6997 1.24995 19.2945 1.32991C19.9223 1.41432 20.4891 1.59999 20.9445 2.05546C21.4 2.51093 21.5857 3.07773 21.6701 3.70552C21.7501 4.30031 21.75 5.04953 21.75 5.94801V21.25H22C22.4142 21.25 22.75 21.5858 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75H2C1.58579 22.75 1.25 22.4142 1.25 22C1.25 21.5858 1.58579 21.25 2 21.25H2.25L2.25 8.948C2.24997 8.04952 2.24994 7.3003 2.32991 6.70552C2.41432 6.07773 2.59999 5.51093 3.05546 5.05546C3.51093 4.59999 4.07773 4.41432 4.70552 4.32991C5.3003 4.24995 6.04952 4.24997 6.948 4.25L10.278 4.25C10.3294 3.37583 10.4906 2.62032 11.0555 2.05546C11.5109 1.59999 12.0777 1.41432 12.7055 1.32991C13.3003 1.24995 14.0495 1.24997 14.948 1.25ZM11.0068 5.75C11.0055 5.75 11.0043 5.75 11.003 5.75C11.002 5.75 11.001 5.75 11 5.75H7C6.03599 5.75 5.38843 5.7516 4.90539 5.81654C4.44393 5.87858 4.24643 5.9858 4.11612 6.11612C3.9858 6.24644 3.87858 6.44393 3.81654 6.90539C3.75159 7.38843 3.75 8.03599 3.75 9V21.25H8.25V19C8.25 18.5858 8.58579 18.25 9 18.25C9.41421 18.25 9.75 18.5858 9.75 19V21.25H14.25V9C14.25 8.03599 14.2484 7.38843 14.1835 6.90539C14.1214 6.44393 14.0142 6.24644 13.8839 6.11612C13.7536 5.9858 13.5561 5.87858 13.0946 5.81654C12.6127 5.75175 11.9671 5.75001 11.0068 5.75ZM15.75 21.25L15.75 8.94801C15.75 8.04953 15.7501 7.30031 15.6701 6.70552C15.5857 6.07773 15.4 5.51093 14.9445 5.05546C14.4891 4.59999 13.9223 4.41432 13.2945 4.32991C12.8691 4.27273 12.3648 4.25645 11.7834 4.25183C11.8335 3.55219 11.9436 3.28863 12.1161 3.11612C12.2464 2.9858 12.4439 2.87858 12.9054 2.81654C13.3884 2.7516 14.036 2.75 15 2.75H17C17.964 2.75 18.6116 2.7516 19.0946 2.81654C19.5561 2.87858 19.7536 2.9858 19.8839 3.11612C20.0142 3.24644 20.1214 3.44393 20.1835 3.90539C20.2484 4.38843 20.25 5.03599 20.25 6V21.25H15.75ZM5.25 8C5.25 7.58579 5.58579 7.25 6 7.25H12C12.4142 7.25 12.75 7.58579 12.75 8C12.75 8.41422 12.4142 8.75 12 8.75H6C5.58579 8.75 5.25 8.41422 5.25 8ZM5.25 11C5.25 10.5858 5.58579 10.25 6 10.25H12C12.4142 10.25 12.75 10.5858 12.75 11C12.75 11.4142 12.4142 11.75 12 11.75H6C5.58579 11.75 5.25 11.4142 5.25 11ZM5.25 14C5.25 13.5858 5.58579 13.25 6 13.25H12C12.4142 13.25 12.75 13.5858 12.75 14C12.75 14.4142 12.4142 14.75 12 14.75H6C5.58579 14.75 5.25 14.4142 5.25 14Z"
                              fill="#1E73FF"
                            />
                          </svg>
                        </div>
                        <Form.Control
                          className="form-control radius-4 ps-5  mt-3 height-50"
                          required
                          type="text"
                          placeholder="Company Name"
                          name="name"
                          onChange={setValue}
                        />
                        <Form.Control.Feedback
                          type="invalid"
                          style={{ position: "absolute" }}
                        >
                          {errors.name}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </div>
                    <div className="col-12">
                      <Form.Group
                        controlId="validationCustom01"
                        className="ms-auto position-relative"
                      >
                        <div className="position-absolute translate-middle-y2 search-icon1 px-3">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M2.25 9C2.25 3.75 7.5 3.75 12 3.75C16.5 3.75 21.75 3.75 21.75 9C21.75 15 16.5 8.25 16.5 8.25H7.5C7.5 8.25 2.25 15 2.25 9ZM8.25 10.5C8.25 10.5 4.5 14.25 4.5 21H19.5C19.5 14.25 15.75 10.5 15.75 10.5H8.25Z"
                              stroke="#1E73FF"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M12 18.75C13.6569 18.75 15 17.4069 15 15.75C15 14.0931 13.6569 12.75 12 12.75C10.3431 12.75 9 14.0931 9 15.75C9 17.4069 10.3431 18.75 12 18.75Z"
                              stroke="#1E73FF"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <Form.Control
                          className="form-control radius-4 ps-5 mt-3 height-50"
                          required
                          type="text"
                          placeholder="Phone Number"
                          name="phoneNo"
                          value={data.phoneNo}
                          onChange={setValue}
                          maxLength={15}
                          minLength={10}
                        />
                        <Form.Control.Feedback
                          type="invalid"
                          style={{ position: "absolute" }}
                        >
                          {errors.phoneNo}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </div>

                    <div className="col-12">
                      <Form.Group
                        controlId="validationCustom01"
                        className="ms-auto position-relative"
                      >
                        <div className="position-absolute translate-middle-y2 search-icon1 px-3">
                          <i
                            class="fadeIn animated bx bx-id-card"
                            style={{
                              fontSize: "23px",
                              position: "relative",
                              top: "-5px",
                              color: "#1e73ff",
                            }}
                          ></i>
                        </div>
                        <Form.Control
                          className="form-control radius-4 ps-5 mt-3 height-50"
                          required
                          type="text"
                          placeholder="Personal/Social security number"
                          name="ssn"
                          value={data.ssn}
                          onChange={setValue}
                          maxLength="15"
                        />
                        <Form.Control.Feedback
                          type="invalid"
                          style={{ position: "absolute" }}
                        >
                          {errors.ssn}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </div>

                    <div className="col-12">
                      <Form.Group
                        controlId="validationCustom01"
                        className="ms-auto position-relative"
                      >
                        <div className="position-absolute translate-middle-y2 search-icon1 px-3">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M6 22C5.45 22 4.979 21.804 4.587 21.412C4.195 21.02 3.99934 20.5493 4 20V10C4 9.45 4.196 8.979 4.588 8.587C4.98 8.195 5.45067 7.99933 6 8H7V6C7 4.61667 7.48767 3.43733 8.463 2.462C9.43834 1.48667 10.6173 0.999334 12 1C13.3833 1 14.5627 1.48767 15.538 2.463C16.5133 3.43833 17.0007 4.61733 17 6V8H18C18.55 8 19.021 8.196 19.413 8.588C19.805 8.98 20.0007 9.45067 20 10V20C20 20.55 19.804 21.021 19.412 21.413C19.02 21.805 18.5493 22.0007 18 22H6ZM6 20H18V10H6V20ZM12 17C12.55 17 13.021 16.804 13.413 16.412C13.805 16.02 14.0007 15.5493 14 15C14 14.45 13.804 13.979 13.412 13.587C13.02 13.195 12.5493 12.9993 12 13C11.45 13 10.979 13.196 10.587 13.588C10.195 13.98 9.99934 14.4507 10 15C10 15.55 10.196 16.021 10.588 16.413C10.98 16.805 11.4507 17.0007 12 17ZM9 8H15V6C15 5.16667 14.7083 4.45833 14.125 3.875C13.5417 3.29167 12.8333 3 12 3C11.1667 3 10.4583 3.29167 9.875 3.875C9.29167 4.45833 9 5.16667 9 6V8Z"
                              fill="#1E73FF"
                            />
                          </svg>
                        </div>
                        <Form.Control
                          className="form-control radius-4 ps-5 mt-3 height-50"
                          required
                          type="password"
                          placeholder="Set up a password"
                          name="password"
                          onChange={setValue}
                          maxLength={15}
                          minLength={8}
                          pattern="^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{7,15}$"
                        />
                        <Form.Control.Feedback
                          type="invalid"
                          style={{ position: "absolute" }}
                        >
                          {errors.password}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </div>
                  </div>
                </Form>
                <div className="col-12 mt-5">
                  <div className="d-grid">
                    <button
                      className="btn btn-primary login-btn height-50"
                      onClick={handleSubmit}
                    >
                      Create my Account
                    </button>
                  </div>
                </div>
                <div className="login-separater text-center mb-4 mt-4">
                  <p>
                    Already have an account ?{" "}
                    <a href="#" className="text-blue">
                      Sign In
                    </a>
                  </p>
                </div>
                <div className="text-center">
                  {/* <a
                    className="btn btn-outline-secondary height-50 text-center w-100 text-center me-3"
                    href="javascript:;"
                  >
                    <span className="d-flex justify-content-center align-items-center pt-1">
                      <img
                        className="me-4"
                        src="assets/images/icons/search.svg"
                        width="22"
                        alt=""
                      />{" "}
                      Sign up with Google
                    </span>
                  </a> */}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showAlert}
        onHide={handleCloseAlert}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <p style={{ textAlign: "center" }}>
            <img src="/assets/img/tappme-logo.png" />
          </p>
          <p>
            <b>Thank you for registering with Tapp Me.</b>
          </p>
          <p>
            We are pleased to inform you that your account has been successfully
            created. However, please be aware that it requires moderation by our
            administrator. You should have received a welcome email outlining
            the necessary steps to proceed. Once your account has been approved,
            you will receive another email prompting you to complete the payment
            for your selected subscription. Following the payment process, your
            account will be activated, and you will receive login credentials
            via email, including a temporary password.
          </p>
          <p>
            Should you require any assistance or further information throughout
            this process, please do not hesitate to contact us via the following
            channels:
          </p>
          <p>
            <b>Phone/Mobile No.:</b>{" "}
            <a href="tel:+46731444238">+46 73 144 42 38</a>
          </p>
          <p>
            <b>Email:</b>{" "}
            <a href="mailto:office@mitaway.com">office@mitaway.com</a>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseAlert}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showForm}
        onHide={handleCloseForm}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#000", fontSize: "18px" }}>
            Connect with Us Through the Form
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={contactValidated} onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Form.Group as={Col} md="12" controlId="validationCustom01">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  required
                  type="text"
                  name="name"
                  maxLength="50"
                  onChange={(e) => typeMessage(e)}
                />
                <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              </Form.Group>
              <Form.Group
                as={Col}
                md="12"
                controlId="validationCustom01"
                className="mt-3"
              >
                <Form.Label>Email</Form.Label>
                <Form.Control
                  required
                  type="Email"
                  name="email"
                  maxLength="50"
                  onChange={(e) => typeMessage(e)}
                />
                <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              </Form.Group>
              <Form.Group
                as={Col}
                md="12"
                controlId="validationCustom01"
                className="mt-3"
              >
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  required
                  type="text"
                  name="phoneNumber"
                  minLength="10"
                  maxLength="15"
                  value={messsageData.phoneNumber}
                  onChange={(e) => typeMessage(e)}
                />
                <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              </Form.Group>
              <Form.Group
                as={Col}
                md="12"
                controlId="validationCustom01"
                className="mt-3"
              >
                <Form.Label>Message</Form.Label>
                <Form.Control
                  as="textarea"
                  required
                  type="number"
                  maxLength="1000"
                  name="message"
                  onChange={(e) => typeMessage(e)}
                />
                <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              </Form.Group>
            </Row>

            {/* <button class="btn btn-primary login-btn height-50 w-100" onClick={contactFormSubmit}>Submit</button> */}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseForm}>
            Close
          </Button>
          <Button variant="primary" onClick={contactFormSubmit}>
            Send
          </Button>
        </Modal.Footer>
      </Modal>

      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          onClose={handleClosse}
        >
          <Alert
            onClose={handleClosse}
            severity={severity}
            sx={{ width: "100%" }}
          >
            {message}
          </Alert>
        </Snackbar>
      </Stack>
    </div>
  );
};

export default LandingPage;
